"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _KatalMetricsDriver2 = _interopRequireDefault(require("./KatalMetricsDriver"));

var _KatalMetricObject = _interopRequireDefault(require("../metricObject/KatalMetricObject"));

var _ErrorHandler = require("./ErrorHandler");

/**
 * Collects metrics into an array.
 *
 * Mainly useful for testing.
 */
var KatalMetricsDriverArrayCollector =
/*#__PURE__*/
function (_KatalMetricsDriver) {
  (0, _inherits2.default)(KatalMetricsDriverArrayCollector, _KatalMetricsDriver);

  /**
   * Create a new metrics array collector
   *
   * @param errorHandler Error handler callback
   */
  function KatalMetricsDriverArrayCollector() {
    var _this;

    var errorHandler = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _ErrorHandler.DEFAULT_ERROR_HANDLER;
    (0, _classCallCheck2.default)(this, KatalMetricsDriverArrayCollector);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(KatalMetricsDriverArrayCollector).call(this));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "metrics", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "beforeUnloadHandlers", []);
    _this.errorHandler = errorHandler;
    return _this;
  }

  (0, _createClass2.default)(KatalMetricsDriverArrayCollector, [{
    key: "getMetricArray",
    value: function getMetricArray() {
      return this.metrics;
    }
  }, {
    key: "clearMetricArray",
    value: function clearMetricArray() {
      this.metrics = [];
    }
  }, {
    key: "getAndClearMetricArray",
    value: function getAndClearMetricArray() {
      var ret = this.getMetricArray();
      this.clearMetricArray();
      return ret;
    }
    /**
     * NOTE: This is an experimental API and may change in the future.
     */

  }, {
    key: "beforeUnload",
    value: function beforeUnload(cb) {
      this.beforeUnloadHandlers.push(cb);
    }
    /**
     * Run the registered beforeUnload handlers and clear them out.
     * NOTE: This is an experimental API and may change in the future.
     * @return The number of handlers that were ran.
     */

  }, {
    key: "runPendingBeforeUnloadHandlers",
    value: function runPendingBeforeUnloadHandlers() {
      this.beforeUnloadHandlers.forEach(function (cb) {
        cb();
      });
      var count = this.beforeUnloadHandlers.length;
      this.beforeUnloadHandlers = [];
      return count;
    } // TODO: errorHandler in this method is deprecated and will be removed.

  }, {
    key: "publish",
    value: function publish(metricObject, errorHandler, context) {
      var fields = (0, _objectSpread2.default)({}, context.getFields());

      switch (metricObject.type) {
        case _KatalMetricObject.default.Types.String:
        case _KatalMetricObject.default.Types.Counter:
        case _KatalMetricObject.default.Types.Timer:
          (0, _extends2.default)(fields, {
            type: metricObject.type,
            metricKey: metricObject.name,
            value: metricObject.value
          });

          if (metricObject.isMonitor) {
            fields.isMonitor = true;
          }

          break;

        default:
          var err = new Error("Unknown type ".concat(metricObject.type, " when publishing metric object."));
          this.errorHandler(err);
          return;
      }

      this.metrics.push(fields);
    }
  }]);
  return KatalMetricsDriverArrayCollector;
}(_KatalMetricsDriver2.default);

exports.default = KatalMetricsDriverArrayCollector;